import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    store: null,
    isInCustomerMode: true,
}

export const storeSlice = createSlice({
    name: 'store',
    initialState,
    reducers: {
        setStore: (state, action) => {
            state.store = action.payload
        },
        updateIsInCustomerMode: (state, action) => {
            state.isInCustomerMode = action.payload
        }
    },
})

export const {
    setStore,
    updateIsInCustomerMode,
} = storeSlice.actions

export default storeSlice.reducer